import { defineStore } from 'pinia'
import { api } from '@/api/client'

export const useUnreadStore = defineStore('unread', {
  state: () => ({
    supportUnread: 0,
    newsUnread: 0,
    _pollTimer: null as ReturnType<typeof setInterval> | null,
  }),

  actions: {
    async refreshSupport(): Promise<void> {
      try {
        const { data } = await api.get<{ success: boolean; unread_count?: number }>(
          '/api/user/messages',
          { params: { mark_read: '0' } },
        )
        if (data.success) {
          this.supportUnread = Math.max(0, data.unread_count ?? 0)
        }
      } catch {
        /* ignore transient errors */
      }
    },

    async refreshNews(): Promise<void> {
      try {
        const { data } = await api.get<{ success: boolean; unread_count?: number }>(
          '/api/user/news',
        )
        if (data.success) {
          this.newsUnread = Math.max(0, data.unread_count ?? 0)
        }
      } catch {
        /* ignore */
      }
    },

    async refreshAll(): Promise<void> {
      await Promise.all([this.refreshSupport(), this.refreshNews()])
    },

    setSupportUnread(count: number): void {
      this.supportUnread = Math.max(0, count)
    },

    setNewsUnread(count: number): void {
      this.newsUnread = Math.max(0, count)
    },

    decNewsUnread(): void {
      if (this.newsUnread > 0) this.newsUnread -= 1
    },

    startPolling(): void {
      this.stopPolling()
      void this.refreshAll()
      this._pollTimer = setInterval(() => void this.refreshAll(), 30_000)
    },

    stopPolling(): void {
      if (this._pollTimer) {
        clearInterval(this._pollTimer)
        this._pollTimer = null
      }
    },
  },
})
